import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserRolesFetchStatus = createSelector(
  [(store: RootState) => store.supervisorHome.userRolesFetchStatus],
  (data) => data
);
